import { UserRole } from '@rundown-studio/types'

export const DashboardPermissions = {
  EVENT_VIEW: 1, // 000001 - View events
  EVENT_EDIT: 2, // 000010 - Edit events
  TEAM_VIEW: 8, // 001000 - View team
  TEAM_EDIT: 16, // 010000 - Edit team
  TEAM_ADMIN: 32, // 100000 - Admin team
} as const

// Role permission sets (precomposed combinations)
export const DashboardRolePermissions: Record<UserRole, number> = {
  [UserRole.EVENT_VIEWER]: DashboardPermissions.EVENT_VIEW,
  [UserRole.EVENT_EDITOR]:
    DashboardPermissions.EVENT_VIEW | DashboardPermissions.EVENT_EDIT,
  [UserRole.EVENT_SHOWCALLER]:
    DashboardPermissions.EVENT_VIEW | DashboardPermissions.EVENT_EDIT,
  [UserRole.TEAM_SHOWCALLER]:
    DashboardPermissions.TEAM_VIEW |
    DashboardPermissions.TEAM_EDIT |
    DashboardPermissions.EVENT_VIEW |
    DashboardPermissions.EVENT_EDIT,
  [UserRole.TEAM_VIEWER]:
    DashboardPermissions.TEAM_VIEW | DashboardPermissions.EVENT_VIEW,
  [UserRole.TEAM_EDITOR]:
    DashboardPermissions.TEAM_VIEW |
    DashboardPermissions.TEAM_EDIT |
    DashboardPermissions.EVENT_VIEW |
    DashboardPermissions.EVENT_EDIT,
  [UserRole.TEAM_ADMIN]:
    DashboardPermissions.TEAM_ADMIN |
    DashboardPermissions.TEAM_VIEW |
    DashboardPermissions.TEAM_EDIT |
    DashboardPermissions.EVENT_VIEW |
    DashboardPermissions.EVENT_EDIT,
  [UserRole.TEAM_BILLING_DEPRECATED]: 0,
  [UserRole.TEAM_MEMBER_DEPRECATED]: 0,
}

export const hasDashboardPermission = (
  userRole: UserRole,
  requiredPermissions: number,
): boolean => {
  const userPermissions = DashboardRolePermissions[userRole]
  return (userPermissions & requiredPermissions) !== 0
}

export const hasMinimumDashboardRole = (
  userRole: UserRole,
  minimumRole: UserRole,
): boolean => {
  const userPermissions = DashboardRolePermissions[userRole]
  const minimumPermissions = DashboardRolePermissions[minimumRole]
  return (userPermissions & minimumPermissions) === minimumPermissions
}
